import styled, { css, keyframes } from 'styled-components';

const scrollAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

export const OuterWrapper = styled.div`
  position: fixed;
  bottom: 60px;
  right: 0;
  width: 45%;
  margin-right: 24px;
  overflow: hidden;
  border-radius: 8px;

  @media (max-width: 1024px) {
    position: fixed;
    bottom: 40px;
    width: 90%
  }

  @media (max-height: 768px) {
    display: none;
  }
`;

export const BackgroundContainer = styled.div<{ direction: 'left' | 'right' }>`
  position: absolute;
  top: 0;
  ${({ direction }) => direction === 'left' ? 'left: 0;' : 'right: 0;'}
  width: 100px;
  height: 100%;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%);
  transform: ${({ direction }) => direction === 'right' ? 'rotateY(180deg)' : 'none'};
  z-index: 1;
`;

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 0;
  width: max-content;
  animation: ${scrollAnimation} 25s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 14px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  box-shadow: 0px 2px 20px 0px rgba(165, 165, 165, 0.12);
  flex-shrink: 0;
  width: 295px;
  min-width: 295px;
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 4px;
`;

export const TestimonialTitle = styled.p`
  font-family: Inter, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.21em;
  letter-spacing: 0.02em;
  text-align: left;
  color: #2563eb;
  margin: 0;
`;

export const TestimonialDescription = styled.p`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.21em;
  letter-spacing: 0.02em;
  text-align: left;
  color: #334155;
  margin: 0;
`;

export const ProfileSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  align-self: stretch;
  gap: 12px;
`;

export const ProfileImage = styled.img`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

export const AvatarPlaceholder = styled.div<{ backgroundColor: string }>`
  display: flex;
  width: 36px;
  height: 36px;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 50%;
  background: ${({ backgroundColor }) => backgroundColor};
  color: #fff;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.2px;
  flex-shrink: 0;
`;

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
`;

export const ProfileName = styled.span`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.21em;
  text-align: center;
  color: #6b6b6b;
`;

export const ProfileBatch = styled.span`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.21em;
  text-align: center;
  color: #6b6b6b;
`;
